
import { useEffect, useState } from "react";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import TopBanner from "./components/TopBanner/TopBanner";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import Products from "./pages/Products/Products";
import Services from "./pages/Services/Services";
import AboutUs from "./pages/AboutUs/AboutUs";
import Contact from "./pages/ContactUs/Contact";
import WhyChooseUs from "./pages/WhyChooseUs/WhyChooseUs";
import Wishlist from "./pages/Wishlist/Wishlist";
import CartPage from "./pages/Cart/CartPage";
import "./App.css";

function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const navigate = (path) => {
    if (window.location.pathname !== path) {
      window.history.pushState({}, "", path);
      setCurrentPath(path);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const renderPage = () => {
    switch (currentPath) {
      case "/":
        return <Home onNavigate={navigate} />;
      case "/products":
        return <Products onNavigate={navigate} />;
      case "/services":
        return <Services />;
      case "/about":
      case "/about-us":
        return <AboutUs />;
      case "/why-us":
        return <WhyChooseUs />;
      case "/contact":
        return <Contact />;
      case "/wishlist":
        return <Wishlist onNavigate={navigate} />;
      case "/cart":
        return <CartPage onNavigate={navigate} />;
      default:
        return <Home onNavigate={navigate} />;
    }
  };

  return (
    <CartProvider>
      <WishlistProvider>
        <div className="App">
          <TopBanner />
          <Navbar currentPath={currentPath} onNavigate={navigate} />
          <main>{renderPage()}</main>
          <Footer />
        </div>
      </WishlistProvider>
    </CartProvider>
  );
}

export default App;